import { FC } from 'react';
import About from '@app/form_components/About';

export const SettingsAboutPage: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <About />
      </div>
    </div>
  );
};

